import { FNV } from './fnv';
/**
 * FNV-1A incremental checksum.
 *
 * @public
 */
var Checksum = /** @class */ (function () {
    function Checksum() {
        this.v = 0;
        this.v = 2166136261 /* FNV1A_BASIS */;
    }
    /**
     * Add the string to the checksum.
     *
     * @public
     */
    Checksum.prototype.update = function (s) {
        this.v = FNV(this.v, s);
        return this;
    };
    /**
     * Get the checksum value.
     *
     * @public
     */
    Checksum.prototype.get = function () {
        return this.v;
    };
    return Checksum;
}());
export { Checksum };
//# sourceMappingURL=checksum.js.map